import useSWR from "swr";
import { API_BASE_URL } from "@/lib/env";
import type { APISubscription } from "@/api/client";

export function useSubscriptions() {
  const { data, error, isLoading, mutate } = useSWR<APISubscription[]>(
    `${API_BASE_URL}/me/subscriptions`,
  );

  return {
    subscriptions: data ?? [],
    isLoading,
    isError: !!error,
    refreshSubscriptions: mutate,
  };
}
